// extracted by mini-css-extract-plugin
module.exports = {"InfoIcon":"InfoIcon-module__InfoIcon___1yH8X"};